import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Class } from './class';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { HttpError } from './errors';
import { SearchStudent } from './searchstudent';

@Injectable()
export class ClassService {
  private loadingErrorBase = new Subject<Boolean>();
  loadingError$ = this.loadingErrorBase.asObservable();

  constructor(private http: HttpClient) { }

  public getAllClasses(): any {
    return this.http.get<Class[]>('/klas').pipe(catchError((error) => {
      this.loadingErrorBase.next(true);
      throw new HttpError(`Error loading all classes`);
    }));
  }

  public searchAllStudents(search: string): any {
    var result = this.http.post<SearchStudent[]>('/klas/SearchStudent', { search: search }).pipe(catchError(error => {
      this.loadingErrorBase.next(false);
      throw new HttpError(`Error searching students`);
    }));

    return result;
  }
}



// WEBPACK FOOTER //
// ./src/app/class.service.ts